import { render, staticRenderFns } from "./configs.vue?vue&type=template&id=f131f486&"
import script from "./configs.vue?vue&type=script&lang=js&"
export * from "./configs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports